export default __webpack_public_path__ + "static/media/icon-operational-procedure.673ae53d.svg";